module.exports = __webpack_public_path__ + "img/1478817696.6f64442b.jpg";